import { render, staticRenderFns } from "./UndoPolicyRelease.vue?vue&type=template&id=03e0dcbc&"
import script from "./UndoPolicyRelease.vue?vue&type=script&lang=js&"
export * from "./UndoPolicyRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports